var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaverBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_3148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4306 13.167C8.98726 13.167 8.62793 13.5263 8.62793 13.9697C8.62793 14.413 8.98726 14.7723 9.4306 14.7723C9.87393 14.7723 10.2333 14.413 10.2333 13.9697C10.2333 13.5273 9.87393 13.167 9.4306 13.167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3613 13.083C16.8844 13.083 16.4971 13.4703 16.4971 13.9473C16.4971 14.4251 16.8844 14.8115 17.3613 14.8115C17.8392 14.8115 18.2256 14.4242 18.2256 13.9473C18.2256 13.4694 17.8383 13.083 17.3613 13.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5391 5.18652H7.461C5.73806 5.18652 4.3418 6.58279 4.3418 8.30572V18.4417C4.3418 20.1647 5.73806 21.5609 7.461 21.5609H13.4931L15.5446 26.3947C15.5446 26.3947 15.6855 26.8137 16.0281 26.8137C16.3706 26.8137 16.5115 26.3947 16.5115 26.3947L18.563 21.5609H24.5401C26.263 21.5609 27.6593 20.1647 27.6593 18.4417V8.30572C27.6583 6.58372 26.2621 5.18652 24.5391 5.18652ZM11.6675 14.1465C11.6582 15.9992 9.74206 16.0524 9.74206 16.0524C9.001 16.0524 8.58286 15.5615 8.58286 15.5615V15.8956H7.18753V10.1416C7.18193 10.1407 7.181 10.1397 7.18753 10.1379V10.1416C7.27433 10.1556 8.58286 10.1379 8.58286 10.1379V12.3387C8.9114 11.7796 9.85966 11.7889 9.85966 11.7889C11.9251 11.9812 11.6675 14.1465 11.6675 14.1465ZM14.1231 11.9653V15.9049H12.7577V12.0045C12.7577 11.4744 12.0997 11.3269 12.0997 11.3269V9.95119C14.2809 10.0399 14.1231 11.9653 14.1231 11.9653ZM17.3609 16.0552C16.0962 16.0552 15.0714 15.1116 15.0714 13.9477C15.0714 12.7839 16.0962 11.8403 17.3609 11.8403C18.6255 11.8403 19.6503 12.7839 19.6503 13.9477C19.6494 15.1116 18.6246 16.0552 17.3609 16.0552ZM24.8415 16.0552C24.8415 16.0552 24.8611 18.0572 22.8274 18.0572H22.2086V16.7608H22.5819C22.5819 16.7608 23.4369 16.8392 23.4266 15.5232C23.4266 15.5232 23.2595 16.0561 22.0611 16.0561C22.0611 16.0561 20.3615 15.9339 20.3615 14.2753V13.6463C20.3615 13.6463 20.4007 11.9271 22.2674 11.7899C22.2674 11.7899 23.0038 11.7115 23.4565 12.32V11.8972H24.8415V16.0552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6708 13.1035C22.2042 13.1035 21.8262 13.4815 21.8262 13.9482C21.8262 14.4148 22.2042 14.7928 22.6708 14.7928C23.1375 14.7928 23.5155 14.4148 23.5155 13.9482C23.5155 13.4815 23.1375 13.1035 22.6708 13.1035Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_3148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverBlog);
export default __webpack_public_path__ + "static/media/naver_blog.0fb6a592090f3ba8fac9b53d136a669a.svg";
export { ForwardRef as ReactComponent };